import { PROPS } from "./layout-props"

// Pure, so the schema, the v2 markdown reader and the importer all write the
// same markup without pulling Tiptap into the portal's render path.

export const FRAME_BLOCK = new RegExp(
	`<Frame${PROPS}>([\\s\\S]*?)<\\/Frame>`,
	"g",
)

/** Every part is HTML already: the caption and hint inline, the media as blocks. */
export function frameHtml({
	hintHtml,
	mediaHtml,
	captionHtml,
}: {
	hintHtml: string
	mediaHtml: string
	captionHtml: string
}): string {
	const hint = hintHtml
		? `<p data-frame-hint class="pl-frame-hint">${hintHtml}</p>`
		: ""
	const caption = captionHtml
		? `<figcaption data-frame-caption class="pl-frame-caption">${captionHtml}</figcaption>`
		: ""
	return `<div data-type="frame" class="pl-frame">${hint}<figure data-type="frame-figure" class="pl-frame-figure"><div data-frame-media class="pl-frame-media">${
		mediaHtml || "<p></p>"
	}</div>${caption}</figure></div>`
}

// A block image node has nowhere to live inside the paragraph a parser wraps it in.
export const liftImages = (html: string): string =>
	html.replace(/<p>\s*((?:<img\b[^>]*>\s*)+)<\/p>/g, "$1")
